<div [style.padding.px]="8">
  @if ((currentDriverState$ | async) === driverState.ADD || (currentDriverState$ | async) === driverState.EDIT) {
    <app-driver-form
      >
    </app-driver-form>
  }

  @if ((currentDriverState$ | async) === driverState.AVATAR) {
    <app-select-avatar></app-select-avatar>
  }

  @if ((currentDriverState$ | async) === driverState.ASSIGN || (currentDriverState$ | async) === driverState.LIST) {
    <app-driver-list
      >
    </app-driver-list>
  }

  @if ((currentDriverState$ | async) === driverState.HISTORY) {
    <app-driver-history></app-driver-history>
  }
</div>

